import { render, staticRenderFns } from "./DPS.vue?vue&type=template&id=7f0f223c&"
import script from "./DPS.vue?vue&type=script&lang=js&"
export * from "./DPS.vue?vue&type=script&lang=js&"
import style0 from "./DPS.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
